import { styled } from "@mui/material/styles";

// Components
import { StyledCard, theme } from "~/components/Common";
import { StyledFormSelect } from "~/components/Layout/LayoutForm/Form.styled";

const styledName = "TransactionList";

export const StyledListWrapper = styled("div", { name: styledName })({
  "&": {
    maxWidth: "100%",
    minWidth: 0,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    flexShrink: 1,
    flexGrow: 1,
  },
});

export const StyledList = styled(StyledCard, { name: styledName })({
  "&": {
    maxWidth: "none",
    padding: "10px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    transition: `all 0.3s ease-in`
  },
});

export const StyledDateList = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "start",
    height: "100%",
    overflowY: "scroll",
  },
});

export const StyledWalletList = styled(StyledFormSelect, { name: styledName })({
  "&": {
    height: "40px",
    width: "200px",
    backgroundColor: "white",
    borderRadius: "10px",
    fontSize: "1.6rem",
    fontWeight: "600",
    color: theme.palette.primary.main,
  },
});

export const StyledLabelWrapper = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    justifyContent: "space-between",
  },
});

export const StyledLoading = styled("div", { name: styledName })({
  "&": {
    height: "100%",
    display: "flex",
    alignItems: "center",
  },
});

export const StyledLoadingMoreTransaction = styled("div", { name: styledName })(
  {
    "&": {
      height: "10px",
    },
  }
);
